<template>
    <div>
        <div class="tabs is-small">
            <ul>
                <router-link
                    :to="{ name: 'client-settings-bonus-rules-content' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Rules content</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-cashback-bonus' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Cashback</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-coupon-bonus' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Coupon</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-deposit-bonus' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Deposit</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-registration-bonus' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Registration</a>
                </router-link>
                <router-link
                    :to="{ name: 'client-settings-welcome-bonus' }"
                    active-class="is-active"
                    tag="li"
                >
                    <a>Welcome</a>
                </router-link>
            </ul>
        </div>

        <router-view />
    </div>
</template>
<script>
export default {
    name: 'client-settings-bonus-index'
};
</script>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/bonuses/index.vue